import { createSlice } from "@reduxjs/toolkit";

export const REQUEST_BRANDS = "REQUEST_BRANDS";
export const RECEIVE_BRANDS = "RECEIVE_BRANDS";

const initialState = {};

const brandsSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    requestBrands: state => state,
    receiveBrands: (state, { payload }) => ({
      ...state,
      ...payload
    })
  }
});

export const { requestBrands, receiveBrands } = brandsSlice.actions;

export default brandsSlice.reducer;
